import api from "@/lib/api";

// Fetch a protected file as a blob and open it in a new tab.
export async function openAuthedFile(path) {
  const w = window.open("", "_blank");
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  if (w) w.location.href = url;
  else window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const isImage = (ct) => typeof ct === "string" && ct.startsWith("image/");
